import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getAbout, getHome, getServices } from "../api/services";
import { prefetchPageBanners } from "../api/queries";
import { preloadBannerImageLink, preloadBannerImages, preloadPageBannerImages } from "../lib/banners";

const SITE_STALE_TIME = 30 * 60 * 1000;

function seedFooterCache(queryClient, home) {
  if (!home) return;
  if (home.about) queryClient.setQueryData(["about"], home.about);
  if (home.services) queryClient.setQueryData(["services"], home.services);
}

export default function BannerPrefetch() {
  const queryClient = useQueryClient();

  useEffect(() => {
    Promise.all([
      prefetchPageBanners(queryClient),
      queryClient
        .prefetchQuery({
          queryKey: ["home"],
          queryFn: getHome,
          staleTime: SITE_STALE_TIME,
        })
        .then(() => {
          const home = queryClient.getQueryData(["home"]);
          seedFooterCache(queryClient, home);
          preloadBannerImages(home?.banners);
          preloadBannerImageLink(home?.banners?.[0]?.image);
        }),
      queryClient.prefetchQuery({
        queryKey: ["about"],
        queryFn: getAbout,
        staleTime: SITE_STALE_TIME,
      }),
      queryClient.prefetchQuery({
        queryKey: ["services"],
        queryFn: async () => {
          const data = await getServices();
          preloadPageBannerImages(
            (data?.items || []).map((item) => item.bannerImageUrl).filter(Boolean)
          );
          return data;
        },
        staleTime: SITE_STALE_TIME,
      }),
    ]).catch(() => {});
  }, [queryClient]);

  return null;
}
